export default function TS_Certificate() {
  return (
    <div>
      <h1>TS Certificate</h1>
      <p>This is the TS Certificate page.</p>
    </div>
  );
}